import { t } from 'i18next';
import * as yup from 'yup';

export default function treatments() {
  return yup
    .array()
    .of(
      yup.object().shape({
        treatmentReference: yup.string().required(),
      }),
    )
    .ensure()
    .min(1, t('errors.requiredTreatments'))
    .default([]);
}
